import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

const parseHTML = (input) => {
  // sanitize with html
  const sanitizedHTMLInput = DOMPurify.sanitize(input);
  // parse to react Elements
  const reactElements = parse(sanitizedHTMLInput);
  return reactElements;
};

export default parseHTML;
